// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".window.popup.new > .content > .entity-edit-form > .body {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
